import './roleDesc.css';
import React, { useContext } from 'react';
import RoomProvider from 'components/Provider/RoomProvider';
import { stylizeKeyword } from 'others/keywords/keywordstyles';

const requestImageFile = require.context('../../assets/roles', true, /.png$/);

function RoleDesc({ role }) {
    const { room } = useContext(RoomProvider);

    return (
        <div id='roleDesc_container'>
            <h1 id='rp_title'>
                {role?.img && <img 
                                        className='role_img'
                                        src={requestImageFile(`./${role?.img}.png`).default} alt='role_icon' 
                                    />}
                <p dangerouslySetInnerHTML={{__html: stylizeKeyword(`[${role?.name}]`, room.players, room.localPlayer)}}/>
                <hr/>
            </h1>
            <p 
                id='rp_desc'
                dangerouslySetInnerHTML={{__html: stylizeKeyword(role?.desc, room.players, room.localPlayer)}} 
            />
        </div>
    );
}

export default RoleDesc;